
import { IOpReducerAction, IOpState } from 'app/redux/Pensions/actions'

type ILocal705OpState = IOpState
type ILocal705OpAction = IOpReducerAction<ILocal705OpState>

const ActionTypes = {
  OP_STARTING: 'local705/OP_STARTING',
  OP_COMPLETED: 'local705/OP_COMPLETED',
  OP_FAILED: 'local705/OP_FAILED'
}

export {
  ActionTypes,
  ILocal705OpAction,
  ILocal705OpState
}



// WEBPACK FOOTER //
// ./src/app/redux/Customers/local705/reducer/index.ts